"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.RETENTION_TYPE = exports.DAILY_OF_KIND = exports.DAY_OF_WEEK = void 0;
var DAY_OF_WEEK;
(function (DAY_OF_WEEK) {
    DAY_OF_WEEK["sunday"] = "sunday";
    DAY_OF_WEEK["monday"] = "monday";
    DAY_OF_WEEK["tuesday"] = "tuesday";
    DAY_OF_WEEK["wednesday"] = "wednesday";
    DAY_OF_WEEK["thursday"] = "thursday";
    DAY_OF_WEEK["friday"] = "friday";
    DAY_OF_WEEK["saturday"] = "saturday";
})(DAY_OF_WEEK = exports.DAY_OF_WEEK || (exports.DAY_OF_WEEK = {}));
var DAILY_OF_KIND;
(function (DAILY_OF_KIND) {
    DAILY_OF_KIND["everyday"] = "everyday";
    DAILY_OF_KIND["weekdays"] = "weekdays";
    DAILY_OF_KIND["selectedDays"] = "selectedDays";
})(DAILY_OF_KIND = exports.DAILY_OF_KIND || (exports.DAILY_OF_KIND = {}));
var RETENTION_TYPE;
(function (RETENTION_TYPE) {
    RETENTION_TYPE["days"] = "days";
    RETENTION_TYPE["months"] = "months";
    RETENTION_TYPE["years"] = "years";
})(RETENTION_TYPE = exports.RETENTION_TYPE || (exports.RETENTION_TYPE = {}));
//# sourceMappingURL=Schedule.js.map